import type {
  AnimalCollectionItem,
  InvestigationCollectionItem,
  LocationCollectionItem,
} from '@nuxt/content'

const [useProvideMapState, useMapState] = createInjectionState(
  (
    locations: Ref<LocationCollectionItem[]>,
    animals: Ref<AnimalCollectionItem[]>,
    articles: Ref<InvestigationCollectionItem[]>,
  ) => {
    const activeLocation = ref<LocationCollectionItem>()

    const { groupBy, groupedLocations } = useGroupLocations(articles, animals, locations)

    return {
      activeLocation,
      locations,
      groupBy,
      groupedLocations,
    }
  },
)

export { useMapState, useProvideMapState }
